const initialState = {
    phoneNumber: '',
    message: '',
    disabledBtn: false,
    isLoading: false,
    btnClass: '', 
};
const support = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_INPUT_PAGE_SUPPORT':
            return {...state, [action.name]: action.value};
        case 'CHANGE_DISABLE_BTN_PAGE_SUPPORT':
            return {...state, disabledBtn: action.disabledBtn};
        case 'CHANGE_LOADER_PAGE_SUPPORT':
            return {...state, isLoading: action.isLoading};
        case 'CHANGE_BTN_CLASS_PAGE_SUPPORT':
            return {...state, btnClass: action.className};
        default:
            return state;
    }
};

export default support;
